export const enum CardPlacement {
  BottomRight = 'bottom-right',
  TopRight = 'top-right',
}
